import './styles.css';
import { VideoRemoteApp } from './app/VideoRemoteApp.js';

new VideoRemoteApp();

